import React, { useContext, useEffect } from 'react'
import JobCard from '../../../layouts/Home/JobCard'
import CommonContext from '../../../hooks/CommonContext';
import Image from "../../../utils/images";
import { Link } from 'react-router-dom';
import JobCardGlow from './JobCardGlow';
import Cookie from "js-cookie";
import { decryptData } from 'Security/Crypto/Crypto';

const HomeRecommended = () => {
    const { applyFilterResponse, setRecommendationBelowSixtyPercentage, recommendationBelowSixtyPercentage, setRecommendedStatus, setApplyFilterCount, getRecommendedData, setSelectedCardPath, setAnswer, setSelectedCardIndex, cardArrayDuplicateSearch, setCardArrayDuplicateSearch, setapplyFilterResponse, refreshId, refreshAction, setCardArray, cardArrayDuplicate, setCardArrayDuplicate, setSelectedCardData, gettingResponse, setGettingResponse, setSortByForPagination, handleSelectedCardData } = useContext(CommonContext);

    useEffect(() => {
        if (refreshAction === false) {
            setRecommendationBelowSixtyPercentage(false);
            setapplyFilterResponse(false)
            setGettingResponse(false)
            setCardArray([])
            setCardArrayDuplicate([])
            setSelectedCardData([])
            setCardArrayDuplicateSearch([])
            setSelectedCardPath(window.location.pathname)
            setSelectedCardIndex(0)
        }

        setRecommendedStatus({
            recommended_by: "",
            sc_recommended_notes: ""
        });
        setSortByForPagination("")
        setApplyFilterCount(0);
        setAnswer([]);
        getRecommendedData();
    }, [refreshId])

    useEffect(() => {
        var getLocalStorageId = Cookie.get("recommended_job_id") ? decryptData(Cookie.get("recommended_job_id")) : '';
        if (isFinite(getLocalStorageId) && getLocalStorageId && gettingResponse && cardArrayDuplicateSearch?.length) {
            handleSelectedCardData(getLocalStorageId);
        }
    }, [Cookie.get("recommended_job_id")])

    return (
        <div className="col-12 h-100 overflow-scroll" id="professionalHomeRecommendedScroll">
            <div className="d-flex justify-content-between py-2 align-items-center">
                <div className="col">
                    {
                        gettingResponse === false ? <label className="filter-results placeholder rounded py-3 w-100"></label>
                            :
                            <p className='showing-results text-secondary mb-0 py-2'>
                                {
                                    cardArrayDuplicate.length ?
                                        `Showing : 1-${cardArrayDuplicate.length} of ${cardArrayDuplicate.length} Recommended Jobs`
                                        :
                                        `Showing : 0 Jobs`
                                }
                            </p>
                    }

                </div>
            </div>


            {/* job card skeleton  */}
            {gettingResponse === false || applyFilterResponse ?
                <JobCardGlow />
                :
                null
            }

            {
                cardArrayDuplicateSearch.length > 0 && gettingResponse ?
                    cardArrayDuplicateSearch.map((value, index) => {
                        return <div className="card w-100 mt-2 rounded-4 border-0" key={index}>
                            <div className="card-body position-relative pt-4" id={`professionalRecommendedJob${index}Card`}>
                                <JobCard
                                    cardHeading={value.job_title}
                                    cardPostedOn={value.created_at}
                                    cardWorkplace={value.workplace_type}
                                    cardState={value.country}
                                    cardSchedule={value.work_schedule}
                                    cardJobType={value.job_type}
                                    cardPayment={value.is_paid === "Y" ? "Paid" : "Volunteer"}
                                    applicationStatus={value.recommended_by}
                                    cardType="recommended"
                                    cardId={value.id}
                                    cardDes={value.job_overview}
                                    cardImage={value.profile_image}
                                    companyName={value.company_name}
                                />
                            </div>
                        </div>

                    })

                    :
                    null
            }

            {
                cardArrayDuplicateSearch.length === 0 && gettingResponse ?
                    <>
                        <div className="d-flex flex-wrap align-items-center justify-content-center noRecordsFound-image-height">
                            <div className='text-center'>
                                <img src={Image.noRecordsFound} className='w-50 h-50' />

                                {recommendationBelowSixtyPercentage ?
                                    <div className="row align-content-center h-100 justify-content-center">
                                        <p className="text-center px-5">
                                            Please take a few moments to complete your profile to increase your chances of receiving better recommendations.
                                            <Link to="/professional/profile" className="px-2">My Profile</Link>
                                        </p>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>

                    </>
                    :
                    null
            }

        </div>
    )
}

export default HomeRecommended
